export { register } from './ripple-base';
